<template>
    <div class='cron-field-item'>
        <span style="color:#999;margin-right: 4px;">{{chsLabels[innerModel.name]}}</span>
        <el-select :disabled="fixedType || fixedValue || innerTypeDisabled" v-model="innerModel.type" @change="syncModel" style="width: 80px">
            <el-option v-for="typeItem in currTypes" :key="typeItem['value']" :label="typeItem['text']" :value="typeItem['value']"></el-option>
        </el-select>
        <div class="cron-field-value" v-if="innerModel.type == 'All'">{{chsLabels[innerModel.name]}}</div>
        <div class="cron-field-value" v-if="innerModel.type == 'Spec'">
            <el-input :disabled="fixedValue" v-model="innerModel.value" type="number" style="width: 80px;;text-align: center" @blur="syncModel"></el-input>
            {{chsNames[innerModel.name]}} <span v-show="isForSpecDay()" style="color:gray;">&nbsp;&nbsp;（提示： -1 代表最后一天）</span>
        </div>
        <div class="cron-field-value" v-if="innerModel.type == 'Span'">
            <el-input :disabled="fixedValue" v-model="innerModel.values[0]" type="number" style="width: 80px;text-align: center" @blur="syncModel"></el-input>
            <span> ~ </span>
            <el-input :disabled="fixedValue" v-model="innerModel.values[1]" type="number" style="width: 80px;;text-align: center" @blur="syncModel"></el-input>
            {{chsNames[innerModel.name]}}
        </div>
        <div class="cron-field-value" v-if="innerModel.type == 'Every'">
            <el-input :disabled="fixedValue" v-model="innerModel.value" type="number" placeholder="可不填" style="width: 80px;text-align: center" @blur="syncModel"></el-input>
            {{chsNames[innerModel.name]}}
            起 每
            <el-input :disabled="fixedValue" v-model="innerModel.freq" type="number" style="width: 80px;;text-align: center" @blur="syncModel"></el-input>
            {{chsQtyNames[innerModel.name]}}
        </div>
        <span v-show="innerModel && innerModel.name == 'Month'" style="float:right;margin-top: 4px; margin-right: 0px;">
            <el-checkbox v-model="useWkDayX" style="color:navy;" @change="syncMonthUseWkDay">使用周天</el-checkbox>
        </span>
        <el-select v-if="innerModel.name == 'WkDay'" v-model="innerModel.wseq" @change="syncModel" style="float:right;margin-right: 0px; width: 80px">
            <el-option v-for="wseqItem in wseqItems" :key="wseqItem['value']" :label="wseqItem['text']" :value="wseqItem['value']"></el-option>
        </el-select>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import {
        CronField
    } from './json-cron.js'

    const chsLabels = {};
    chsLabels[CronField.NAME.Year] = "年份";
    chsLabels[CronField.NAME.Month] = "月份";
    chsLabels[CronField.NAME.WkDay] = "周天";
    chsLabels[CronField.NAME.Day] = "日期";
    chsLabels[CronField.NAME.Hour] = "时钟";
    chsLabels[CronField.NAME.Minute] = "分钟";
    chsLabels[CronField.NAME.Second] = "秒钟";

    const chsNames = {};
    chsNames[CronField.NAME.Year] = "年";
    chsNames[CronField.NAME.Month] = "月";
    chsNames[CronField.NAME.WkDay] = "周天";
    chsNames[CronField.NAME.Day] = "日";
    chsNames[CronField.NAME.Hour] = "时";
    chsNames[CronField.NAME.Minute] = "分";
    chsNames[CronField.NAME.Second] = "秒";

    const chsQtyNames = {};
    chsQtyNames[CronField.NAME.Year] = "年";
    chsQtyNames[CronField.NAME.Month] = "个月";
    chsQtyNames[CronField.NAME.WkDay] = "周天";
    chsQtyNames[CronField.NAME.Day] = "天";
    chsQtyNames[CronField.NAME.Hour] = "个小时";
    chsQtyNames[CronField.NAME.Minute] = "分钟";
    chsQtyNames[CronField.NAME.Second] = "秒钟";

    const initSpanValues = {};
    initSpanValues[CronField.NAME.Year] = new Array(new Date().getFullYear(), new Date().getFullYear() + 1);
    initSpanValues[CronField.NAME.Month] = new Array(1, 2);
    initSpanValues[CronField.NAME.WkDay] = new Array(2, 6);
    initSpanValues[CronField.NAME.Day] = new Array(1, 2);
    initSpanValues[CronField.NAME.Hour] = new Array(8, 17);
    initSpanValues[CronField.NAME.Minute] = new Array(0, 30);
    initSpanValues[CronField.NAME.Second] = new Array(0, 30);
    //暂不支持List
    let Types_all = [{
        value: CronField.TYPE.Spec,
        text: '固定'
    }, {
        value: CronField.TYPE.Span,
        text: '范围'
    }, {
        value: CronField.TYPE.All,
        text: '所有'
    }, {
        value: CronField.TYPE.Every,
        text: '重复'
    }, {
        value: CronField.TYPE.List,
        text: '列表'
    }];

    //年份可用的
    let Types_year_names = [CronField.TYPE.Spec, CronField.TYPE.Span, CronField.TYPE.All];
    const Types_year = Types_all.filter(function (item) {
        return Types_year_names.indexOf(item.value) != -1;
    });

    let Types_wkday_names = [CronField.TYPE.Spec, CronField.TYPE.Span, CronField.TYPE.All];
    const Types_wkday = Types_all.filter(function (item) {
        return Types_wkday_names.indexOf(item.value) != -1;
    });

    let Types_comn_names = [CronField.TYPE.Spec, CronField.TYPE.Span, CronField.TYPE.All, CronField.TYPE.Every];
    const Types_comn = Types_all.filter(function (item) {
        return Types_comn_names.indexOf(item.value) != -1;
    });
    //
    const WSEQ_ITEMS = Utils.copyAsArray(CronField.WSEQ_ITEMS);
    //
    export default {
        name: 'swb-cron-field-item',
        desc: 'Cron表达式域',
        props: {
            //CronField
            model: {
                type: Object,
                default: null
            },
            fixedType: {
                type: Boolean,
                default: false
            },
            //是否固定值（不能更改，所以必须事先给定值）
            fixedValue: {
                type: Boolean,
                default: false
            },
            //是否使用周天（仅对月份有效）
            useWkDay: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                chsLabels: chsLabels,
                chsNames: chsNames,
                chsQtyNames: chsQtyNames,
                wseqItems: Utils.copyAsArray(WSEQ_ITEMS),
                innerTypeDisabled: false,
                //
                currTypes: [],
                //仅对月份有效
                useWkDayX: false,
                //仅对周天有效哦
                innerModel: null,
            };
        },
        computed: {},
        watch: {
            model(newVal, oldVal) {
                this.doInit();
            },
            fixedType(newVal, oldVal) {
                this.doInit();
            },
            fixedValue(newVal, oldVal) {
                this.doInit();
            },
            useWkDay(newVal, oldVal) {
                this.doInit();
            }
        },
        created() {
            this.doInit();
        },
        methods: {
            doInit() {
                this.useWkDayX = this.useWkDay;
                //
                this.innerModel = this.model == null ? new CronField().toJson() : this.model.toJson();
                //
                let fieldName = this.innerModel.name;
                switch(fieldName) {
                    case CronField.NAME.Year :
                        this.currTypes = Utils.merge(Types_year);
                        break;

                    case CronField.NAME.WkDay :
                        this.currTypes = Utils.merge(Types_wkday);
                        break;

                    default :
                        this.currTypes = Utils.merge(Types_comn);
                        break;
                }
                //
                if(this.innerModel.values == null || this.innerModel.values.length != 2) {
                    this.innerModel.values = Utils.merge(initSpanValues[this.innerModel.name]);
                    //console.log(this.innerModel.values);
                }
                //
                if(fieldName == CronField.NAME.WkDay) {
                    if(this.innerModel.wseq == null) {//初始化周次
                        this.innerModel.wseq = 0;
                    }
                }
                //
                if(this.fixedValue) {
                    this.innerModel.type = CronField.TYPE.Spec;
                }
                setTimeout(this.syncModel, 1000);
            },
            isForSpecDay() {
                let currName = this.innerModel.name;
                let currType = this.innerModel.type;
                return currName == CronField.NAME.Day && currType == CronField.TYPE.Spec;
            },
            //
            getModel() {
                let newModel = Utils.merge(this.innerModel);
                //
                let currName = newModel.name;
                if(currName != CronField.NAME.WkDay) {
                    delete newModel['wseq'];
                }
                //
                let currType = newModel.type;
                if(currType != CronField.TYPE.Every) {
                    delete newModel['freq'];
                }
                if(!(currType == CronField.TYPE.Span || currType == CronField.TYPE.List)) {
                    delete newModel['values'];
                }
                if(currType == CronField.TYPE.All) {
                    delete newModel['value'];
                }
                //转换数据类型
                if(typeof newModel['value'] != 'undefined') {
                    newModel['value'] = Utils.ParseInt(newModel['value']);
                }
                if(typeof newModel['freq'] != 'undefined') {
                    newModel['freq'] = Utils.ParseInt(newModel['freq']);
                }
                if(typeof newModel['wseq'] != 'undefined') {
                    newModel['wseq'] = Utils.ParseInt(newModel['wseq']);
                }
                if(typeof newModel['values'] != 'undefined') {
                    newModel['values'] = newModel['values'].map(function (val) {
                        return Utils.ParseInt(val);
                    });
                }
                //
                return newModel;
            },
            syncWkDayUI() {
                let innerModel = this.innerModel;
                let name = innerModel.name;
                if(name == CronField.NAME.WkDay) {
                    let wseq = innerModel.wseq;
                    if(wseq != 0 && innerModel.type != CronField.TYPE.Spec) {
                        this.$set(this.innerModel, 'type', CronField.TYPE.Spec);
                    }
                    this.innerTypeDisabled = wseq != 0;
                }
            },
            syncModel() {
                this.syncWkDayUI();
                //
                this.$emit('change', this.getModel());
            },
            syncMonthUseWkDay() {
                this.$emit('month-useWkDay', this.useWkDayX);
            }
        }
    }
</script>

<style scoped>
    .cron-field-item {
        font-size: 14px;
        padding: 4px;
    }

    .cron-field-item .cron-field-value {
        display: inline-block;
    }

    .cron-field-item .cron-field-value .el-input > input[type=number].el-input__inner {
        color: blue;
    }

</style>



// WEBPACK FOOTER //
// src/compo/cron/CronFieldItem.vue